import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'eyrus-questionnaire-splash',
  templateUrl: './splash.component.html',
  styleUrls: ['./splash.component.sass']
})
export class QuestionnaireSplashComponent implements OnInit {

  type: String = 'general';
  private queryParams: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.queryParams = this.route.snapshot.queryParams;
    this.type = this.route.snapshot.data.viewType;
  }

  goToQuesttionnaire() {
    const _url = this.router.url;
    const newUrl = _url.replace(`/access/${this.type}`, `/add/${this.type}`);
    this.router.navigate([newUrl]);
  }


}
